export const isEmptyString = (string?: string) =>
  !string || string?.length === 0;

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
